/*
 * Lemonade Training Oy, copy rights, all right reserved.
 * Schedule board callable wrappers.
 */

import { httpsCallable } from "firebase/functions";
import { firebaseFunctions } from "../store/firebaseApp";
import type {
  RecordScheduleViewChangedRequest,
  RecordScheduleViewChangedResponse,
} from "@lemonadetraining/contracts";

// async so a synchronous throw inside httpsCallable still reaches the caller's .catch.
export const recordScheduleViewChanged = async (
  data: RecordScheduleViewChangedRequest
): Promise<RecordScheduleViewChangedResponse> => {
  const fn = httpsCallable<RecordScheduleViewChangedRequest, RecordScheduleViewChangedResponse>(
    firebaseFunctions,
    "recordScheduleViewChanged"
  );
  return (await fn(data)).data;
};
